import { Reducer } from 'redux';

// TODO: cleanup unused

// Actions

// export const closeIncorrectWalletChainModal = () => ({
//   type: 'USER_GUIDE_CLOSE_INCORRECT_WALLET_CHAIN' as const,
// });

export const toggleNotifications = (enabled = true) => ({
  type: 'USER_GUIDE_NOTIFICATIONS_TOGGLE' as const,
  enabled,
});

export const closedLargeSpreadMarketOrderModal = (closed = true) => ({
  type: 'USER_GUIDE_CLOSE_LARGE_SPREAD_MARKET_ORDER' as const,
  closed,
});

export const closedIsolatedMarginWarningModal = (closed = true) => ({
  type: 'USER_GUIDE_CLOSE_ISOLATED_MARGIN_WARNING' as const,
  closed,
});

export const closeWelcomeModal = (display = false) => ({
  type: 'USER_GUIDE_CLOSE_WELCOME_MODAL' as const,
  display,
});

export const devResetGuides = () => ({
  type: 'DEV_RESET_GUIDES' as const,
});

export const changeSkipBuySellConfirmation = (skip: boolean) => ({
  type: 'USER_GUIDE_SKIP_BUYSELL_CONFIRMATION' as const,
  skip,
});

export const skipCancelOrderConfirmation = (skip = true) => ({
  type: 'USER_GUIDE_SKIP_CANCEL_ORDER_CONFIRMATION' as const,
  skip,
});

export const skipDesktopQRConnectModal = (skip = true) => ({
  type: 'SKIP_DEKSTOP_QR_CONNECT' as const,
  skip,
});

type UserGuideAction = ReturnType<
  // | typeof closeIncorrectWalletChainModal
  | typeof devResetGuides
  | typeof closedLargeSpreadMarketOrderModal
  | typeof closedIsolatedMarginWarningModal
  | typeof closeWelcomeModal
  | typeof changeSkipBuySellConfirmation
  | typeof skipCancelOrderConfirmation
  | typeof skipDesktopQRConnectModal
  | typeof toggleNotifications
>;

// Reducer

type UserGuide = {
  // visitedBalancesPageAfterFirstUnock: boolean;
  // closedIncorrectWalletChainId: boolean | undefined;
  closedLargeSpreadMarketOrderWarning: boolean | undefined;
  /** "Don't show again" for the first order in an isolated margin market warning */
  closedIsolatedMarginWarning: boolean | undefined;
  closedWelcomeModal: boolean | undefined;
  skipBuySellConfirmation: boolean;
  skipCancelOrderConfirm: boolean;
  skipQrConnectModal: boolean;
  notificationsDisabled: boolean;
};

const defaultState: UserGuide = {
  // visitedBalancesPageAfterFirstUnock: false,
  // For new users always false
  // closedIncorrectWalletChainId: false,
  closedLargeSpreadMarketOrderWarning: false,
  closedIsolatedMarginWarning: false,
  closedWelcomeModal: false,
  skipBuySellConfirmation: false,
  skipCancelOrderConfirm: false,
  skipQrConnectModal: false,
  notificationsDisabled: false,
};

// @cached
export const userGuideReducer: Reducer<UserGuide, UserGuideAction> = (
  state = defaultState,
  action
): UserGuide => {
  switch (action.type) {
    case 'DEV_RESET_GUIDES':
      return defaultState;
    // case 'USER_GUIDE_CLOSE_INCORRECT_WALLET_CHAIN':
    //   return {
    //     ...state,
    //     closedIncorrectWalletChainId: true,
    //   };
    case 'USER_GUIDE_CLOSE_LARGE_SPREAD_MARKET_ORDER':
      return {
        ...state,
        closedLargeSpreadMarketOrderWarning: action.closed,
      };
    case 'USER_GUIDE_CLOSE_ISOLATED_MARGIN_WARNING':
      return {
        ...state,
        closedIsolatedMarginWarning: action.closed,
      };
    case 'USER_GUIDE_CLOSE_WELCOME_MODAL':
      return {
        ...state,
        closedWelcomeModal: !action.display,
      };
    case 'USER_GUIDE_SKIP_BUYSELL_CONFIRMATION':
      return {
        ...state,
        skipBuySellConfirmation: action.skip,
      };
    case 'USER_GUIDE_SKIP_CANCEL_ORDER_CONFIRMATION':
      return {
        ...state,
        skipCancelOrderConfirm: action.skip,
      };
    case 'SKIP_DEKSTOP_QR_CONNECT':
      return {
        ...state,
        skipQrConnectModal: action.skip,
      };
    case 'USER_GUIDE_NOTIFICATIONS_TOGGLE': {
      return {
        ...state,
        notificationsDisabled: !action.enabled,
      };
    }
    default:
      return state;
  }
};
